<template>
  <div>
    <div class="content">
      <div class="content-main">
        <p class="content-title">渠道用户管理<un-lock/><page-desc/></p>
        <div class="content-input">
          <div class="content-input-left">
            <div class="content-input-item">
              <label>渠道名称</label>
              <el-select v-model="channelId" placeholder="Select" class="select-item">
                <el-option v-for="item in channelIdArray" :key="item.id" :label="item.name" :value="item.id">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <label>用户状态</label>
              <el-select v-model="userState" placeholder="Select" class="select-item">
                <el-option v-for="item in userStateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType"  :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
              <el-checkbox v-model="limitState" style="margin-left: 8px"><span style="white-space: nowrap">有限制</span></el-checkbox>
            </div>
            <div class="content-input-item">
              <label style="width: 8em">是否提交过保障单</label>
              <el-select v-model="medicalState" placeholder="Select" class="select-item">
                <el-option v-for="item in medicalStateArray" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <div class="content-input-item">
              <DatePickerRange title="进入时间" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
            </div>

          </div>
          <div class="content-input-right">
            <div class="content-input-btn">
              <ElButtons type="primary" icon="search" v-loading="searchLoading" :disable="searchLoading" @click="getPage(true)"> 查询 </ElButtons>
            </div>
            <div class="content-input-btn">
              <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
            </div>
          </div>


        </div>
      </div>
      <div class="content-main">
        <div class="content-button">
          <div>

          </div>
          <BtnGroup :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
        </div>
        <div class="content-table">
          <el-table
              ref="multipleTableRef"
              :data="pageDataList"
              style="width: 100%; "
              v-loading="listLoading"
              @cell-click="toggleSelection"
              size="default"
              border
              @sort-change="sortChange"
          >
            <!--            <el-table-column property="id" label="ID" v-if="checkColList.indexOf('ID') > -1"/>-->
            <el-table-column property="createTime" label="进入时间" v-if="checkColList.indexOf('进入时间') > -1" sortable='custom'/>
            <el-table-column property="" label="用户信息" v-if="checkColList.indexOf('用户信息') > -1">
              <template #default="scope">
                <p>主人：{{scope.row.name}}</p>
                <p>性别：{{scope.row.sex == 1?'男':scope.row.sex == 2?'女':''}}</p>
                <p>手机：{{scope.row.phone}}</p>
                <p>门店：{{scope.row.shopName}}</p>
                <p>主人ID：{{scope.row.uid}}</p>
              </template>
            </el-table-column>
            <el-table-column property="" label="用户状态" v-if="checkColList.indexOf('用户状态') > -1">
              <template #default="scope">
                <div v-if="scope.row.userId > 0 || scope.row.phone">
                  <p v-if="scope.row.userId > 0 && scope.row.phone">已绑定</p>
                  <p v-if="scope.row.userId <= 0 && scope.row.phone">已注册</p>
                </div>
                <p v-else>未注册</p>
              </template>
            </el-table-column>
            <el-table-column property="channelName" label="渠道" v-if="checkColList.indexOf('渠道') > -1"/>
            <el-table-column property="applyNum" label="已提交保障单" v-if="checkColList.indexOf('已提交保障单') > -1" sortable='custom' class-name="cursor">
              <template #default="scope">
                <span style="color: #3a8ee6">{{scope.row.medicalSecurityApplyNum}}</span>
              </template>
            </el-table-column>
            <el-table-column property="notApplyNum" label="剩余保障名额" v-if="checkColList.indexOf('剩余保障名额') > -1" sortable='custom'>
              <template #default="scope">
                <span>{{scope.row.medicalSecurityNotApplyNum}}</span>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
          </el-pagination>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { getFormData, postFormData } from "@/api/api";
import {getChannelUserPageList, getAllChannelList} from "@/api/url";
import Dialog from "@/assets/js/dialog"
import BtnGroup from '../../components/BtnGroup'
import SearchComponents from "@/components/SearchComponents";
import unLock from "@/layout/components/unLock";
import DatePickerRange from "@/components/DatePickerRange";
import UserInfo from "@/components/User/userInfo"
import inviteListDialog from "@/views/invite/components/inviteListDialog";
import invitePrizeDialog from "@/views/invite/components/invitePrizeDialog";
import securityListDialog from "@/views/medical/components/securityListDialog";
import SysWechatDialog from "@/views/shop/components/SysWechatDialog";
import medicalNumDialog from "@/views/medical/components/medicalNumDialog";

export default {
  name: "ChannelUser",
  components: { BtnGroup, SearchComponents, unLock, DatePickerRange, UserInfo},
  data() {
    return {
      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,
      updateLoading: false,

      channelIdArray: [
        {name: '不限', id: 0},
      ],
      channelIdArr:[],
      channelId: 0,


      medicalStateArray: [
        {label: '不限', value: -1},
        {label: '否', value: 0},
        {label: '是', value: 1},
      ],
      medicalState: -1,

      userStateArray: [
        {label: '不限', value: -1},
        {label: '未注册', value: 0},
        {label: '已注册', value: 1},
        {label: '已绑定', value: 2},
      ],
      userState: -1,

      //刷新组
      colList: ['进入时间', '用户信息', '用户状态', '渠道', '已提交保障单', '剩余保障名额'],
      checkColList: [],

      //搜索
      searchTypeList: [
        {label : '手机号', value : 1},
        {label : '主人', value : 2},
        {label : '主人ID', value : 3},
        {label : '宠物昵称', value : 4},
        {label : '用户备注', value : 5},
      ],
      searchType: 1,
      searchValue: '',


      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      limitState: true,

      sort: 2,

    }
  },
  methods: {
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.limitState = true;
      this.channelId = 0;
      this.medicalState = -1;
      this.sort = 2;
      this.userState = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },
    getCheck(val) {
      this.isChecked = val
    },

    getSearchType(e) {
      this.searchType = e;
    },
    getSearchValue(e) {
      this.searchValue = e;
    },

    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    //排序
    sortChange(column) {
      this.sort = 2;
      if(column.prop == 'createTime') {
        if(column.order == 'descending') {
          this.sort = 1;
        } else if(column.order == 'ascending') {
          this.sort = 2;
        }
      }else if(column.prop == 'applyNum') {
        if(column.order == 'descending') {
          this.sort = 3;
        } else if(column.order == 'ascending') {
          this.sort = 4;
        }
      } else if(column.prop == 'notApplyNum') {
        if(column.order == 'descending') {
          this.sort = 5;
        } else if(column.order == 'ascending') {
          this.sort = 6;
        }
      }
      this.getPage();
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['channelId'] = this.channelId;
      param['medicalState'] = this.medicalState;
      param['userState'] = this.userState;
      param['endTime'] = this.endTime;
      param['startTime'] = this.startTime;
      param['searchType'] = this.searchType;
      param['searchValue'] = this.searchValue;
      param['limitState'] = this.limitState?1:0;
      param['sort'] = this.sort;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getChannelUserPageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      //邀请名单
      if(column.label == '已提交保障单' && row.medicalSecurityApplyNum) {
        Dialog.open({
          title: '已提交保障单',
          component: securityListDialog,
          data: {
            userAppletId: row.id,
            width: '1100px'
          },
          close: () => {

          }
        })
      }

    },


    editUserGiveNum() {
      Dialog.open({
        title: '赠送保障名额',
        component: medicalNumDialog,
        data: {
          width: '750px',
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },


    getChannelList() {
      getFormData(getAllChannelList).then(data => {
        this.channelIdArray = [...this.channelIdArray, ...data.data]
      })
    }



  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
    this.getChannelList();
  }
}
</script>

<style scoped>
/*.el-table {*/
/*  --el-table-header-bg-color: #ffffff !important;*/
/*}*/
</style>
